/**
 * OfflineBanner - Reconflux
 *
 * App-wide banner shown while the browser reports no network connection
 * (issue #264). Mounted once at the app root (main.tsx), in normal document
 * flow above <App />, so it's visible on every route — not just the
 * authenticated AppLayout shell — and pushes content down rather than
 * overlapping it.
 */
import { useNetworkStatus } from '../../hooks/useNetworkStatus'

export function OfflineBanner() {
  const online = useNetworkStatus()
  if (online) return null

  return (
    <div
      role="status"
      className="w-full pt-safe bg-danger text-white text-sm font-medium text-center py-2 px-4"
    >
      You're offline. Live data and some actions are unavailable until you reconnect.
    </div>
  )
}
